import { useRouteTransitionPending } from '@/client/hooks/use-transition-location';
import { useEffect, useState } from 'react';

// Fixed 2px progress bar under the top edge while a route transition is
// pending (the old page stays visible, so this is the only navigation
// feedback). The 150ms arming delay keeps instant transitions (warm chunks,
// prefetched routes) from flashing it.
export const RouteTransitionIndicator = () => {
  const isPending = useRouteTransitionPending();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isPending) {
      setVisible(false);
      return;
    }
    const timer = setTimeout(() => setVisible(true), 150);
    return () => clearTimeout(timer);
  }, [isPending]);

  if (!visible) return null;
  return <div className="fixed top-0 left-0 right-0 z-60 h-0.5 bg-primary animate-pulse" aria-hidden="true" />;
};
